import * as React from 'react';

import { Col, Form, Radio, Row, Space } from 'antd';
import { useAppDispatch, useAppSelector } from 'src/types/reduxHelpers';

import { InterviewComponent } from 'src/components/interviewComponents/types/interviewComponent';
import { nameof } from 'ts-simple-nameof';
import { setAboutCompany } from 'src/store/modules/interviewModule';
import { useTranslation } from 'react-i18next';

interface AboutCompanyProps {

}

interface AboutCompanyFormValues {
    isOrientationUseful: boolean;
    isSafeWorkPriority: boolean;
    isStaffSufficent: boolean;
    isFacilityClean: boolean;
    isSupervisorTrainingProvided: boolean;
    isSupervisorPositive: boolean;
    isSupervisorAcknowledge: boolean;
    isSupervisorProfessionalRelationship: boolean;
    isOpenDoorPolicyPracticed: boolean;
    isPolicyMaintained: boolean;
    isBusinessInclusive: boolean;
}

export const AboutCompany: InterviewComponent<AboutCompanyProps> = React.forwardRef((props, ref) => {
    const { t } = useTranslation();

    const dispatch = useAppDispatch();

    const [form] = Form.useForm<AboutCompanyFormValues>();

    const aboutCompany = useAppSelector((state) => state.interview.aboutCompany);

    React.useImperativeHandle(ref, () => ({
        submit: async () => {
            try {
                await form.validateFields();

                form.submit();

                return true;
            } catch (err) {
                return false;
            }
        },
    }));

    return (
        <Row
            align="middle"
            justify="center"
            gutter={[30, 20]}
        >
            <Col
                span={24}
            >
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={(values) => {
                        console.table(values);

                        // We're storing 'agree'/'disagree'/'not applicable' values as:
                        // agree = true
                        // disagree = false
                        // not applicable = null
                        // but the form values have issues when defaulting to null.

                        // Lets make the 'not applicable' values 'na' and convert back and forth as needed
                        dispatch(setAboutCompany({
                            isOrientationUseful: values.isOrientationUseful,
                            isSafeWorkPriority: values.isSafeWorkPriority,
                            isStaffSufficent: values.isStaffSufficent,
                            isFacilityClean: values.isFacilityClean,
                            isSupervisorTrainingProvided: values.isSupervisorTrainingProvided,
                            isSupervisorPositive: values.isSupervisorPositive,
                            isSupervisorAcknowledge: values.isSupervisorAcknowledge,
                            isSupervisorProfessionalRelationship: values.isSupervisorProfessionalRelationship,
                            isOpenDoorPolicyPracticed: values.isOpenDoorPolicyPracticed,
                            isPolicyMaintained: values.isPolicyMaintained,
                            isBusinessInclusive: values.isBusinessInclusive,
                        }));
                    }}
                >
                    {/* Question 12 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.AboutCompany.is_orientation_useful_label')}
                        name={nameof<AboutCompanyFormValues>(x => x.isOrientationUseful)}
                        rules={[{ required: true }]}
                        // Tan : refered back to jobDetail.tsx //
                        initialValue={aboutCompany?.isOrientationUseful}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                    {/* Question 13 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.AboutCompany.is_safe_work_priority_label')}
                        name={nameof<AboutCompanyFormValues>(x => x.isSafeWorkPriority)}
                        rules={[{ required: true }]}
                        // Tan : refered back to jobDetail.tsx //
                        initialValue={aboutCompany?.isSafeWorkPriority}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                    {/* Question 14 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.AboutCompany.is_staff_sufficient_label')}
                        name={nameof<AboutCompanyFormValues>(x => x.isStaffSufficent)}
                        rules={[{ required: true }]}
                        // Tan : refered back to jobDetail.tsx //
                        initialValue={aboutCompany?.isStaffSufficent}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                    {/* Question 15 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.AboutCompany.is_facility_clean_label')}
                        name={nameof<AboutCompanyFormValues>(x => x.isFacilityClean)}
                        rules={[{ required: true }]}
                        // Tan : refered back to jobDetail.tsx //
                        initialValue={aboutCompany?.isFacilityClean}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                    {/* Question 16 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.AboutCompany.is_supervisor_training_provided_label')}
                        name={nameof<AboutCompanyFormValues>(x => x.isSupervisorTrainingProvided)}
                        rules={[{ required: true }]}
                        // Tan : refered back to jobDetail.tsx //
                        initialValue={aboutCompany?.isSupervisorTrainingProvided}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                    {/* Question 17 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.AboutCompany.is_supervisor_positive_label')}
                        name={nameof<AboutCompanyFormValues>(x => x.isSupervisorPositive)}
                        rules={[{ required: true }]}
                        // Tan : refered back to jobDetail.tsx //
                        initialValue={aboutCompany?.isSupervisorPositive}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                    {/* Question 18 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.AboutCompany.is_supervisor_acknowledge_label')}
                        name={nameof<AboutCompanyFormValues>(x => x.isSupervisorAcknowledge)}
                        rules={[{ required: true }]}
                        // Tan : refered back to jobDetail.tsx //
                        initialValue={aboutCompany?.isSupervisorAcknowledge}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                    {/* Question 19 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.AboutCompany.is_supervisor_professional_relationship_label')}
                        name={nameof<AboutCompanyFormValues>(x => x.isSupervisorProfessionalRelationship)}
                        rules={[{ required: true }]}
                        // Tan : refered back to jobDetail.tsx //
                        initialValue={aboutCompany?.isSupervisorProfessionalRelationship}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                    {/* Question 20 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.AboutCompany.is_open_door_policy_practiced')}
                        name={nameof<AboutCompanyFormValues>(x => x.isOpenDoorPolicyPracticed)}
                        rules={[{ required: true }]}
                        // Tan : refered back to jobDetail.tsx //
                        initialValue={aboutCompany?.isOpenDoorPolicyPracticed}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                    {/* Question 21 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.AboutCompany.is_policy_maintained')}
                        name={nameof<AboutCompanyFormValues>(x => x.isPolicyMaintained)}
                        rules={[{ required: true }]}
                        // Tan : refered back to jobDetail.tsx //
                        initialValue={aboutCompany?.isPolicyMaintained}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                    {/* Question 22 */}
                    <Form.Item
                        label={t('Components.InterviewComponents.AboutCompany.is_business_inclusive')}
                        name={nameof<AboutCompanyFormValues>(x => x.isBusinessInclusive)}
                        rules={[{ required: true }]}
                        // Tan : refered back to jobDetail.tsx //
                        initialValue={aboutCompany?.isBusinessInclusive}
                    >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={true}>
                                    {t('Common.agree')}
                                </Radio>
                                <Radio value={false}>
                                    {t('Common.disagree')}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>

                </Form>
            </Col>
        </Row>
    );
});

AboutCompany.displayName = 'WagesAndBenefits';